export default {
    COPY: 'copy',
    MOVE_COPY: 'moveCopy',
    MULTI_SELECT: 'multiSelect',
    SELECT_FILE: 'selectFile',
    SELECT_FOLDER: 'selectFolder',
};
